import axios from 'axios'
import { courseLoadingError, courseLoadingSuccess, questionsAreLoading, questionsLoadError, questionsLoadSuccess, quizLoadingError, quizLoadingSuccess, quizzesIsLoading, selectedCourseError, selectedCourseIsLoading, selectedCourseSuccess, selectedQuizError, selectedQuizIsLoading, selectedQuizSuccess, isAnswering, answerSubmitSuccess, answerSubmitError, leadershipBoardIsLoading, leadershipBoardLoadingSuccess, leadershipBoardLoadingError, statisticsIsLoading, statisticsLoadingSuccess, statisticsLoadingError, announcementsIsLoading, announcementsLoadingSuccess, announcementsLoadingError, myActivityIsLoading, myActivityLoadingSuccess, myActivityLoadingError, liveCoursesIsLoading, liveCourseLoadingSuccess, liveCourseLoadingError, topicStart, topicStartSuccess, topicStartError, loadComments, commentsLoadSuccess, commentsLoadError, changeFavouriteValue, endSettingFavourite, startSettingFavourite } from '../actions/action';
const url = "https://www.weclassicon.com/elearn/";

export const loadCourses = () => {
    return async(dispatch) => {
        // dispatch(coursesIsLoading());
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            let allCourses = []
            let filters = ['U', 'P', 'C', 'E']
            for (let i = 0; i < filters.length; i++) {
                let response = await axios.get(url + "api/user/courses?status=" + filters[i], { headers: { 'Authorization': 'Bearer ' + token } });
                let courseData = [];
                if (response.data.payload.data) {
                    courseData = [...response.data.payload.data]
                }
                while (response.data.payload.next_page_url) {
                    response = await axios.get(response.data.payload.next_page_url + '&status=' + filters[i], { headers: { 'Authorization': 'Bearer ' + token } });
                    courseData = courseData.concat(response.data.payload.data);
                }
                courseData = courseData.filter(course => course.status.toUpperCase() === 'Y')
                courseData.sort(
                    (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
                );
                allCourses.push(courseData)
            }
            console.log(allCourses)
            dispatch(courseLoadingSuccess(allCourses));
        } catch (error) {
            console.log(error.response.data.message)
            dispatch(courseLoadingError(error.response.data.message));
        }
    };
};

export const loadSelectedCourse = (id) => {
    return async(dispatch) => {
        dispatch(selectedCourseIsLoading())
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            let response = await axios.get(url + 'api/user/course/' + id, { headers: { 'Authorization': 'Bearer ' + token } })
            let course = response.data.payload
            console.log(course)
            dispatch(selectedCourseSuccess(course))
        } catch (error) {
            dispatch(selectedCourseError(error.response.data.message))
        }
    }
}

export const loadQuizzes = () => {
    return async(dispatch) => {
        dispatch(quizzesIsLoading());
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            let allQuizzes = []
            let filters = ['U', 'C', 'A', 'M']
            for (let i = 0; i < filters.length; i++) {
                let response = await axios.get(url + "api/user/quizz?status=" + filters[i], { headers: { 'Authorization': 'Bearer ' + token } });
                console.log(response)
                let quizData = []
                if (response.data.payload.data) {
                    quizData = [...response.data.payload.data]
                }
                while (response.data.payload.next_page_url) {
                    response = await axios.get(response.data.payload.next_page_url + '&status=' + filters[i], { headers: { 'Authorization': 'Bearer ' + token } });
                    console.log(response.data.payload, "next_page")
                    quizData = quizData.concat(response.data.payload.data);
                }

                quizData.sort(
                    (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
                );
                allQuizzes.push(quizData)
            }
            console.log(allQuizzes, "all quizzes")
            dispatch(quizLoadingSuccess(allQuizzes));
        } catch (error) {
            console.log(error.response.data.message, "Quiz load error")
            dispatch(quizLoadingError(error.response.data.message));
        }
    };
};

export const loadSelectedQuiz = (id) => {
    return async(dispatch) => {
        dispatch(selectedQuizIsLoading())
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            let response = await axios.get(url + 'api/user/quizz/' + id, { headers: { 'Authorization': 'Bearer ' + token } })
            let quiz = response.data.payload
            console.log(quiz)
            dispatch(selectedQuizSuccess(quiz))
        } catch (error) {
            dispatch(selectedQuizError(error.response.data.message))
        }
    }
}

export const loadQuizQuestions = (id) => {
    return async(dispatch) => {
        dispatch(questionsAreLoading())
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            let response = await axios.get(url + `api/user/quiz_questions/${id}`, { headers: { 'Authorization': 'Bearer ' + token } })
            let questions = response.data.payload;
            console.log(questions)
            dispatch(questionsLoadSuccess(questions))
        } catch (error) {
            dispatch(questionsLoadError(error.response.data.message))
        }
    }
}

export const answerQuestion = (answerObject) => {
    return async(dispatch) => {
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            dispatch(isAnswering())
            await axios.post(url + 'api/user/quizz', answerObject, { headers: { 'Authorization': 'Bearer ' + token } })
            dispatch(answerSubmitSuccess())
        } catch (error) {
            console.log(error.response.data.message)
            dispatch(answerSubmitError(error.response.data.message))
        }
    }
}

export const loadLeadershipBoard = () => {
    return async(dispatch) => {
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            dispatch(leadershipBoardIsLoading());
            let response = await axios.get(url + 'api/user/leadership_dashboard', { headers: { 'Authorization': 'Bearer ' + token } })
            let leadershipBoardData = [...response.data.payload.data];

            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                leadershipBoardData = leadershipBoardData.concat(response.data.payload.data);
            }

            leadershipBoardData.sort((a, b) => b.scores_count - a.scores_count)
            dispatch(leadershipBoardLoadingSuccess(leadershipBoardData));
        } catch (error) {
            dispatch(leadershipBoardLoadingError(error.response.data.message));
        }
    };
};

export const loadStatistics = () => {
    return async(dispatch) => {
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            dispatch(statisticsIsLoading());
            let response = await axios.get(url + 'api/user/dashboard', { headers: { 'Authorization': 'Bearer ' + token } })
            let statisticsData = {...response.data.payload };
            dispatch(statisticsLoadingSuccess(statisticsData));
        } catch (error) {
            dispatch(statisticsLoadingError(error.response.data.message));
        }
    };
};

export const loadAnnouncements = () => {
    return async(dispatch) => {
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            dispatch(announcementsIsLoading());
            let response = await axios.get(url + 'api/user/announcements', { headers: { 'Authorization': 'Bearer ' + token } })
            let announcementsData = []
            if (response.data.payload.data.length) {
                announcementsData = [...response.data.payload.data];
            }
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                announcementsData = announcementsData.concat(
                    response.data.payload.data
                );
            }
            announcementsData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            console.log(announcementsData)
            dispatch(announcementsLoadingSuccess(announcementsData));
        } catch (error) {
            dispatch(announcementsLoadingError(error.response.data.message));
        }
    };
};

export const startTopic = (id, courseId) => {
    return async(dispatch) => {
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        dispatch(topicStart(id))
        try {
            let response = await axios.post(url + 'api/user/course_join', {
                course_id: courseId,
                topic_id: id
            }, {
                headers: { 'Authorization': 'Bearer ' + token }
            })

            response = await axios.get(url + 'api/user/course/' + courseId, { headers: { 'Authorization': 'Bearer ' + token } })
            let course = response.data.payload
            dispatch(selectedCourseSuccess(course))
            dispatch(topicStartSuccess())
                // let quizList = response.data.payload.quiz
        } catch (error) {
            dispatch(topicStartError())
                // dispatch(quizListLoadingError(error.response.data.message))
        }
    }
}

export const formatMyActivityData = (data) => {
    let newData = []
    let newActivityObject = {}
    for (let i = 0; i < data.length; i++) {
        if (!('activity' in newActivityObject)) {
            newActivityObject.activity = []
        }
        if (!('day' in newActivityObject)) {
            newActivityObject.day = data[i].date
        }
        if (newActivityObject.day === data[i].date) {
            newActivityObject.activity.push(data[i])
        } else {
            newData.push(newActivityObject)
            newActivityObject = {}
            i--
        }
    }
    if ('day' in newActivityObject) {
        newData.push(newActivityObject)
    }
    // newData.sort((a,b) => Date.parse(b.day) - Date.parse(a.day))
    return newData
}

export const loadMyActivity = () => {
    return async(dispatch) => {
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            dispatch(myActivityIsLoading());
            let response = await axios.get(url + 'api/user/my_activity', { headers: { 'Authorization': 'Bearer ' + token } })
            let myActivityData = []
            if (response.data.payload.length) {
                myActivityData = [...response.data.payload];
            }
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                myActivityData = myActivityData.concat(
                    response.data.payload
                );
            }
            // let formattedData = formatMyActivityData(myActivityData)
            // console.log(formattedData)
            myActivityData.sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
            dispatch(myActivityLoadingSuccess(myActivityData));
        } catch (error) {
            dispatch(myActivityLoadingError(error.response.data.message));
        }
    };
};

export const loadLiveCourses = () => {
    return async(dispatch) => {
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        dispatch(liveCoursesIsLoading());
        try {
            let response = await axios.get(url + "api/user/meetings", { headers: { 'Authorization': 'Bearer ' + token } });
            let liveCourseData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                liveCourseData = liveCourseData.concat(response.data.payload.data);
            }
            liveCourseData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            dispatch(liveCourseLoadingSuccess(liveCourseData));
        } catch (error) {
            dispatch(liveCourseLoadingError(error.response.data.message));
        }
    };
};


export const loadCourseComments = (id) => {
    return async(dispatch) => {
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        dispatch(loadComments());
        try {
            let response = await axios.get(url + "api/course_comments/" + id, { headers: { 'Authorization': 'Bearer ' + token } });
            let commentsData = [...response.data.payload.data];
            while (response.data.payload.next_page_url) {
                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });
                commentsData = commentsData.concat(response.data.payload.data);
            }
            console.log(commentsData)
            commentsData.sort(
                (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
            );
            dispatch(commentsLoadSuccess(commentsData));
        } catch (error) {
            dispatch(commentsLoadError(error.response.data.message));
        }
    };
};

export const postComment = async(comment, id) => {

    const token = JSON.parse(localStorage.getItem("user")).message.access_token
    try {
        await axios.post(url + "api/user/course_comments", {
            course_id: id,
            comment: comment
        }, { headers: { 'Authorization': 'Bearer ' + token } });

        return true
    } catch (error) {
        console.log(error)
        return false
    }
}

//non-redux api call

export const loadTopics = async() => {
    try {
        let response = await axios.get(url + "api/topics");
        let topicsData = [...response.data.payload.data];
        while (response.data.payload.next_page_url) {
            response = await axios.get(response.data.payload.next_page_url);
            topicsData = topicsData.concat(response.data.payload.data);
        }
        return topicsData
    } catch (error) {
        throw error
    }
}


export const getScoreAndScorecard = async(id) => {
    const token = JSON.parse(localStorage.getItem("user")).message.access_token
    try {
        let score = []
        let response = await axios.get(url + `api/user/quiz_scores/${id}`, { headers: { 'Authorization': 'Bearer ' + token } })
        console.log(response.data.payload)
        score.push(response.data.payload)
        response = await axios.get(url + `api/user/score_card/${id}`, { headers: { 'Authorization': 'Bearer ' + token } })
        console.log(response.data.payload)
        score.push(response.data.payload)
        console.log(score)
        return score
    } catch (error) {
        throw error
    }
}

export const registerUser = async(registerData) => {
    try {
        let response = await axios.post(url + "api/register", registerData);
        console.log(response.data.payload)
        return true
    } catch (error) {
        throw error
    }
}

export const handleFavourite = (id) => {
    return async(dispatch) => {
        dispatch(startSettingFavourite())
        const token = JSON.parse(localStorage.getItem("user")).message.access_token
        try {
            let response = await axios.post(url + `api/user/course_favourites`,{course_id:id}, { headers: { 'Authorization': 'Bearer ' + token } })
            console.log(response.data)
            dispatch(changeFavouriteValue(id))
        } catch (error) {
            dispatch(endSettingFavourite())
            console.log(error)
        }
    }
}